import * as types from '../mutation-types'

const state = {
  passwordStatus: {
    status: 'normal'
  }
}

// getters
const getters = {
  getpasswordStatus: state => state.passwordStatus
}

// actions
const actions = {
  setpasswordStatus ({ commit, state }, passwordStatus) {
    commit(types.GET_PASSWORDSTATUS, { passwordStatus })
  }
}

// mutations
const mutations = {
  [types.GET_PASSWORDSTATUS] (state, { passwordStatus }) {
    state.passwordStatus = passwordStatus
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/passwordStatus.js